import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { WalletRead } from "@/domains/wallet";
import { MyWalletService } from "@/domains/wallet/services";
import { RootState } from "@/stores";

interface OperatorManageWalletState {
  loading: boolean;
  wallets: WalletRead[];
  total: number;
  pageQuery: HttpPageQuery;
}

const initialState: OperatorManageWalletState = {
  loading: false,
  wallets: [],
  total: 0,
  pageQuery: {
    page_index: 1,
    page_size: 10,
  },
};

export const operatorManageWalletSelects = {
  loading: (state: RootState) => state.operatorManageWallet.loading,
  wallets: (state: RootState) => state.operatorManageWallet.wallets,
  total: (state: RootState) => state.operatorManageWallet.total,
  pageQuery: (state: RootState) => state.operatorManageWallet.pageQuery,
};

export const operatorManageWalletThunks = {
  list: createAsyncThunk(
    "operatorManageWallet/list",
    async (pageQuery: HttpPageQuery) => {
      const res = await MyWalletService.list().setQuery(pageQuery).run();
      return res.data.msg;
    }
  ),
};

export const operatorManageWalletSlice = createSlice({
  name: "operatorManageWallet",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(operatorManageWalletThunks.list.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      operatorManageWalletThunks.list.fulfilled,
      (state, action) => {
        state.loading = false;
        state.wallets = action.payload.wallets;
        if (action.payload.page) {
          state.pageQuery = {
            page_index: action.payload.page?.index,
            page_size: action.payload.page?.size,
          };
          state.total = action.payload.page.total;
        }
      }
    );
    builder.addCase(operatorManageWalletThunks.list.rejected, (state) => {
      state.loading = false;
      state.wallets = [];
    });
  },
});

export const operatorManageWalletActions = operatorManageWalletSlice.actions;
